import * as React from 'react'

function SvgHsbc(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="60"
      height="35"
      viewBox="0 0 60 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8.08984 9H24.2342V25.0118H8.08984V9Z" fill="white" />
      <path
        d="M32.3063 17.0247L24.2342 9V25.0306L32.3063 17.0247ZM16.162 17.0247L24.2342 9H8.08984L16.162 17.0247Z"
        fill="#DB0011"
      />
      <path
        d="M0 17.0247L8.09116 25.0306V9L0 17.0247ZM16.1633 17.0247L8.09116 25.0306H24.2355L16.1633 17.0247Z"
        fill="#DB0011"
      />
      <path
        d="M39.3922 17.4957H36.4672V20.359H35.0048V13.6529H36.4672V16.4031H39.3922V13.6529H40.8547V20.359H39.3922V17.4957ZM44.3875 20.4908C42.925 20.4908 41.7284 19.9069 41.7094 18.3057H43.1719C43.1909 19.0215 43.6087 19.4548 44.4065 19.4548C44.9953 19.4548 45.679 19.1534 45.679 18.4941C45.679 17.9666 45.2232 17.8159 44.4634 17.5899L43.9696 17.458C42.906 17.1566 41.8424 16.7422 41.8424 15.5366C41.8424 14.0484 43.2479 13.5398 44.5204 13.5398C45.831 13.5398 46.9706 13.9919 46.9896 15.4801H45.5271C45.4701 14.8773 45.1092 14.5194 44.4255 14.5194C43.8746 14.5194 43.3428 14.8019 43.3428 15.4047C43.3428 15.8945 43.7987 16.0452 44.7483 16.3466L45.3181 16.5161C46.4767 16.8741 47.2175 17.2696 47.2175 18.3999C47.1985 19.9069 45.717 20.4908 44.3875 20.4908ZM48.0342 13.6717H50.3894C50.8262 13.6529 51.282 13.6717 51.7189 13.747C52.5356 13.9354 53.1624 14.4629 53.1624 15.3671C53.1624 16.2336 52.6116 16.6668 51.8139 16.8741C52.7255 17.0436 53.4093 17.4957 53.4093 18.4941C53.4093 20.0199 51.8898 20.359 50.7122 20.359H48.0532L48.0342 13.6717ZM50.3894 16.4596C51.0351 16.4596 51.6999 16.3278 51.6999 15.5554C51.6999 14.8585 51.0921 14.6701 50.4843 14.6701H49.4587V16.4596H50.3894ZM50.5223 19.3606C51.2061 19.3606 51.8708 19.2099 51.8708 18.381C51.8708 17.5522 51.301 17.4015 50.5983 17.4015H49.4397V19.3606H50.5223ZM57.208 20.4908C55.0237 20.4908 54.0551 19.1157 54.0551 17.0624C54.0551 15.0092 55.1377 13.521 57.2839 13.521C58.6325 13.521 59.943 14.1238 59.981 15.6308H58.4615C58.3855 14.9526 57.9297 14.6136 57.2839 14.6136C55.9544 14.6136 55.5555 16.0264 55.5555 17.1001C55.5555 18.1738 55.9544 19.4171 57.227 19.4171C57.8917 19.4171 58.3855 19.0592 58.4805 18.381H60C59.848 19.9257 58.6135 20.4908 57.208 20.4908Z"
        fill="black"
      />
    </svg>
  )
}

export default SvgHsbc
